export enum RetailRentalMenuEnum {
  overview = 0,
  retailUnitSize,
  retailRentMallWise,
  retailUnit,
}
